import styled from "styled-components";
import SVG from "react-inlinesvg";

export const ButtonContainer = styled.div`
  display: inline-flex;
  cursor: pointer;
`;

export const ButtonBox = styled.button`
  position: relative;
  padding: 9px 30px;
  margin: 0;
  color: var(--button-text-color);
  background-color: transparent;
  border: 1px solid var(--bg-button);
  transition: background-color 500ms linear;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    display: block;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    background-color: rgba(45, 55, 72, 0);
    border-radius: 0;
    cursor: pointer;
    transition: background-color 500ms linear;
  }

  &:hover,
  &:focus,
  &:active,
  &.active {
    background-color: var(--bg-button);
  }

  &:disabled {
    opacity: 0.5;
    
    &:hover,
    &:focus {
      background-color: inherit;
      cursor: default;

      &::before {
        cursor: default;
      }
    }

    &::after {
      display: none;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: -3px;
    left: -70px;
    width: 40px;
    height: calc(100% + 6px);
    background-color: rgba(255,255,255, .3);
    transform: skewX(-30deg);
    animation: slide 3s infinite linear;
    pointer-events: none;
  }

  @keyframes slide {
    0% {
      left: -70px;
    }
    20%, 100% {
      left: calc(100% + 10px);
    }
  }
`;

export const ButtonBoxWithBg = styled(ButtonBox)`
  background-color: var(--bg-button);

  &:hover,
  &:focus,
  &:active,
  &.active {
    background-color: var(--bg-button);

    &::before {
      background-color: rgba(45, 55, 72, 0.15);
    }
  }

  &:disabled {    
    &:hover,
    &:focus {
      background-color: var(--bg-button);

      &::before {
        background-color: transparent;
    }
    }
  }
`;

export const ButtonBackBox = styled(ButtonBox)`
  width: 50px;
  height: 40px;
  padding: 0;
  margin-right: 10px;
  color: var(--bg-back-button);
  background-color: transparent;
  border: 1px solid var(--bg-back-button);
  transform: matrix(-1, 0, 0, 1, 0, 0);
  transition: background-color 500ms linear, border 500ms linear;

  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    display: block;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    /* background-color: rgba(45, 55, 72, 0); */
    border-radius: 0;
    transition: background-color 500ms linear, color 500ms linear;
  }

  &:hover,
  &:focus,
  &:active,
  &.active {
    color: #000;
    background-color: var(--article-bg);
    border: 1px solid var(--article-bg);

    &::before {
      background-color: var(--article-bg);
    }
  }

  &::after {
    display: none;
  }
`;

export const ButtonBackBoxWithBg = styled(ButtonBackBox)`
  color: #000;
  background-color: var(--article-bg);
  border: 1px solid var(--article-bg);
`;

export const ButtonTitle = styled.span`
  font-weight: 500;
  font-size: 12px; //10
  line-height: 1.33; //1.6
`;

export const Icon = styled(SVG)`
  /* margin-left: 15px; */
  fill: currentColor;
`;

export const ButtonBoxCircleWithBorder = styled(ButtonBox)`
  border-radius: 20px;
`;

export const ButtonBoxCircle = styled(ButtonBoxWithBg)`
  border-radius: 20px;
`;

export const ButtonBackBoxCircleWithBorder = styled(ButtonBackBox)`
  border-radius: 20px;
`;

export const ButtonBackBoxCircle = styled(ButtonBackBoxWithBg)`
  border-radius: 20px;
`;

export const ButtonBoxOvalWithBorder = styled(ButtonBox)`
  border-radius: 10px;
`;

export const ButtonBoxOval = styled(ButtonBoxWithBg)`
  border-radius: 10px;
`;

export const ButtonBackBoxOvalWithBorder = styled(ButtonBackBox)`
  border-radius: 10px;
`;

export const ButtonBackBoxOval = styled(ButtonBackBoxWithBg)`
  border-radius: 10px;
`;
